import { css } from '@emotion/core';

export default {
  popper: css`
    z-index: 2;
  `,
};
